/**
 * Media Module Routes
 *
 * Route definitions for the Media module.
 */

import type { RouteRecordRaw } from 'vue-router'
import ModuleLayout from '@/layouts/ModuleLayout.vue'

const routes: RouteRecordRaw[] = [
    {
        path: '/media',
        component: ModuleLayout,
        meta: {
            moduleKey: 'media_library',
        },
        children: [
            {
                path: '',
                name: 'media-list',
                component: () => import('./views/MediaList.vue'),
                meta: {
                    title: 'Media Library',
                },
            },
            {
                path: ':id',
                name: 'media-detail',
                component: () => import('./views/MediaDetail.vue'),
                meta: {
                    title: 'Media Details',
                },
            },
        ],
    },
]

export default routes
